import { useCountryCode } from 'legacy/lut/hooks/useCountryCode'
import { useEffect, useState } from 'react'

import { ValidatedByCountryFields } from 'clickNgo/configs/validation'
import { TValidateFunction } from 'clickNgo/models/utils'
import { fetchValidationInfoByCountry } from 'clickNgo/services/validation'

interface IUseValidateByCountry {
  countryName: string
  field: ValidatedByCountryFields | ''
}

/**
 * Третий элемент кортежа (`hasRule`) добавлен позже и намеренно поставлен в конец: существующие
 * вызовы деструктурируют `[onValidate, isRequired]` и продолжают работать без изменений.
 * Порядок первых двух элементов менять нельзя.
 */
export const useValidateByCountry = ({
  countryName = '',
  field = '',
}: IUseValidateByCountry): [TValidateFunction<string>, boolean, boolean] => {
  const [onValidate, setOnValidate] = useState<TValidateFunction<string>>(() => () => '')
  const [isRequired, setIsRequired] = useState(false)
  const [hasRule, setHasRule] = useState(false)
  const countryCode = useCountryCode(countryName)

  useEffect(() => {
    if (countryCode && field) {
      fetchValidationInfoByCountry({
        countryCode,
        field,
      }).then(({ validateFn, isRequired, hasRule }) => {
        setOnValidate(() => validateFn)
        setIsRequired(isRequired)
        setHasRule(hasRule)
      })
    }
  }, [countryCode, field])

  return [onValidate, isRequired, hasRule]
}
